import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      // Hide when reaching the pricing section or footer
      const scrollY = window.scrollY;
      const pricingEl = document.getElementById('pricing');
      const pricingTop = pricingEl ? pricingEl.offsetTop - window.innerHeight : Infinity;
      if (scrollY > 600 && scrollY < pricingTop) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-260">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 w-full p-4 bg-bgHero/90 backdrop-blur-md border-t border-[rgba(232,197,245,0.2)] z-50 md:hidden" data-id="element-261">
          <button onClick={scrollToPricing} className="w-full cta-primary font-bold py-3.5 rounded-xl shadow-lg flex items-center justify-center gap-2 text-sm" data-id="element-262">
            → QUIERO DORMIR BIEN
          </button>
        </motion.div>}
    </AnimatePresence>;
}